"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var icons_1 = require("@ant-design/icons");
var formik_1 = require("formik");
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var utils_1 = require("../../../utils/utils");
var LinkButton_1 = __importDefault(require("../../Button/LinkButton"));
var Field_1 = __importDefault(require("../components/Field"));
var Label_1 = __importDefault(require("../components/Label"));
var Input_1 = __importDefault(require("../inputs/Input"));
var StyledLabel = styled_components_1.default(Label_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-self: baseline;\n  margin-top: 1em;\n"], ["\n  align-self: baseline;\n  margin-top: 1em;\n"])));
var CloseIconWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 17px;\n  margin-left: 10px;\n"], ["\n  margin-top: 17px;\n  margin-left: 10px;\n"])));
var CloseIcon = styled_components_1.default(icons_1.CloseCircleFilled)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n  color: #005285;\n  font-size: 16px;\n  text-align: inherit;\n"], ["\n  cursor: pointer;\n  color: #005285;\n  font-size: 16px;\n  text-align: inherit;\n"])));
var FlexBox = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 9fr 1fr;\n  margin-bottom: 1em;\n"], ["\n  display: grid;\n  grid-template-columns: 9fr 1fr;\n  margin-bottom: 1em;\n"])));
var TextFieldAdd = function (_a) {
    var name = _a.name, label = _a.label, addText = _a.addText;
    var _b = formik_1.useField(name), field = _b[0], meta = _b[1], helpers = _b[2];
    var value = field.value || [];
    react_1.useEffect(function () {
        if (!value.length) {
            helpers.setValue(ramda_1.append({ value: '' }, value));
        }
    }, []);
    var handleAdd = function () {
        helpers.setValue(ramda_1.append({ value: '' }, value));
    };
    var handleRemove = function (index) {
        if (value.length === 1)
            helpers.setValue(ramda_1.set(ramda_1.lensIndex(index), { value: '' }, value));
        else
            helpers.setValue(ramda_1.remove(index, 1, value));
    };
    var handleChange = function (val, index) {
        var _a;
        if (val === null) {
            helpers.setValue(ramda_1.set(ramda_1.lensIndex(index), undefined, value));
        }
        else {
            helpers.setValue(ramda_1.set(ramda_1.lensIndex(index), { value: val, id: (_a = value[index]) === null || _a === void 0 ? void 0 : _a.id }, value));
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Field_1.default, null,
            label && react_1.default.createElement(StyledLabel, { htmlFor: utils_1.NormalizeString(name) }, label),
            react_1.default.createElement("div", null,
                ramda_1.addIndex(ramda_1.map)(function (val, index) {
                    return (react_1.default.createElement(FlexBox, { key: index },
                        react_1.default.createElement(Input_1.default, { value: val === null || val === void 0 ? void 0 : val.value, name: name, hasError: !!meta.error, onChange: function (v) { return handleChange(v.target.value, index); } }),
                        react_1.default.createElement(CloseIconWrapper, null,
                            react_1.default.createElement(CloseIcon, { onClick: function () { return handleRemove(index); }, key: "remove-" + index }))));
                }, value),
                react_1.default.createElement(LinkButton_1.default, { type: "button", onClick: handleAdd, name: "pridat" }, addText || '+ Přidat další')))));
};
TextFieldAdd.defaultProps = {
    addText: undefined,
};
exports.default = TextFieldAdd;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
